module.exports = __webpack_public_path__ + "media/proksee-viewer/images/fb-circular-752e81f48004fab72ac559df7e1d2cae.png";